import request, { Methods, withToken, RequestType } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_FILES_PROVIDER_RESET = 'POST_FILES_PROVIDER_RESET';
export const POST_FILES_PROVIDER_LOADING = 'POST_FILES_PROVIDER_LOADING';
export const POST_FILES_PROVIDER_SUCCESS = 'POST_FILES_PROVIDER_SUCCESS';
export const POST_FILES_PROVIDER_REJECT = 'POST_FILES_PROVIDER_REJECT';

//* ACTIONS ------------------------------------------------
export const postFilesProviderReset = () => ({ type: POST_FILES_PROVIDER_RESET });
export const postFilesProviderLoading = () => ({ type: POST_FILES_PROVIDER_LOADING });
export const postFilesProviderSuccess = (payload) => ({ type: POST_FILES_PROVIDER_SUCCESS, payload });
export const postFilesProviderReject = (payload) => ({ type: POST_FILES_PROVIDER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postFilesProviderRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        headers: RequestType.Multipart,
        data,
    }, getState);

    return request(`/Providers/web/AddProviderUploadFile`, options);
};


